/**
 * This function returns the Donor messages coming from SF for a logged in user
 * @param {String} sfid `REQUIRED` The for user default centerID
 * @param {Array} messages `REQUIRED` The array of objects containing centerID and messages_list of the center
 * _messages : array that matches with the centerID
 * _messagesList : filters _messages for message_type as Donor and active_message
 * @returns [array] Donor message details
 */

export const getSFDonorMsgs = (sfid, messages) => {
    let centerID = sfid
    if (messages && messages.length && centerID) {
      const _messages = messages.find((item) => item.centerID === centerID)
      if (_messages && _messages?.list.length) {
        const { list } = _messages
        const _messageList = list?.filter((item) => item?.message_type__c === 'Donor' && item?.is_active__c).sort((m1, m2) => m2.id - m1.id)
        return _messageList
      }
    }
  }